import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectDataForCart } from 'wave_solder_pallets/store/selectors';
import { buildFormData } from 'wave_solder_pallets/store/builder';
import { orderProduct } from 'shared/api/apiOrder';
import { doReQuote } from 'wave_solder_pallets/api/quote';

export const doQuote = createAsyncThunk(
  'wsp/doQuote',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId } = currentState.wsp;
    const authToken = document.getElementsByName('authenticity_token')[0].value;

    return doReQuote(
      parameters,
      authToken,
      variantId,
      parameters.product_quote_number,
    );
  },
  {
    condition: ({ name }) => {
      const alterPrice = [
        'material_type_thickness',
        'hold_down_board_quantity',
        'pallet_need_top_hat',
        'pallet_need_stiffener_bar',
        'through_hole_component_pressed_quantity',
        'pallet_length',
        'pallet_width',
        'carrier_thickness',
      ];

      if (!alterPrice.includes(name)) {
        return false;
      }

      return true;
    },
  },
);

export const addToCart = createAsyncThunk(
  'wsp/addToCart',
  async (_args, thunkAPI) => {
    const currentState = thunkAPI.getState();
    const { parameters, variantId, quantity } = selectDataForCart(currentState);
    const form = buildFormData({ parameters, variantId, quantity });

    // eslint-disable-next-line no-undef
    const inputFile = $('#filename');
    const file = inputFile ? inputFile.prop('files')[0] : null;

    if (file) {
      form.append('parameters[filename]', file);
    }

    return orderProduct(form);
  },
);
